import { gql } from "@apollo/client";

export const FINANCIALS_QUERY = gql`
    query NetSales(        
        $timePeriod: TimePeriod
        $highlightsTimePeriod: TimePeriod
        $netSalesFilter: NetSalesFilterWithSubBrandInput
        $salesFilter: SalesFilterInput
        $salesFilterWithSubBrand: SalesFilterWithSubBrandInput
        ) {
        netSales (filter: $netSalesFilter) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        costOfGoodsSold (filter: $salesFilterWithSubBrand) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        grossProfit (filter: $salesFilterWithSubBrand) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        eBit (filter: $salesFilterWithSubBrand) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        closingBalance (filter: $salesFilterWithSubBrand) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        stockAmount (filter: $salesFilter) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        
        profitabilityBySubBrand(timePeriod: $highlightsTimePeriod, filter: $salesFilter) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        grossProfitByCategory(timePeriod: $timePeriod, filter: $salesFilter) {
            items {
                categoryName
                percentage
            }
        }
        grossProfitBySubBrand (filter: $salesFilter) {
            items {
            percentage
            subBrandSubcategory
            }
        }

         profitabilityByDistributorByFinancial(timePeriod: $highlightsTimePeriod, filter: $salesFilter) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        profitabilityByRetailerByFinancial(timePeriod: $highlightsTimePeriod, filter: $salesFilter) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        netSalesBySubBrandMonthlyGrouped (filter: $netSalesFilter) {
            items {
                month
                values {
                    netSalesAmount
                    subBrandName
                    unitsSold
                }
            }
        }

        cashBalanceAndInventory {
            items {
                cashBalance
                cashIn
                cashOut
                grossProfitAmount
                monthYear
                netCashFlow
                netSalesAmount
                stockAmount
            }
        }

        revenueToEBIT (filter: $netSalesFilter) {
            item {
                cmcogs
                cmebit
                cmGrossProfit
                cmGrossSales
                cmNetSales
                cmOperatingExpense
                cmTradeSpend
                cqcogs
                cqebit
                cqGrossProfit
                cqGrossSales
                cqNetSales
                cqOperatingExpense
                cqTradeSpend
                cycogs
                cyebit
                cyGrossProfit
                cyGrossSales
                cyNetSales
                cyOperatingExpense
                cyTradeSpend
            }
        }

        
        

       
    }

`;